import { useState } from 'react';

const useCopy = (couponCode: string, delay: number) => {
  const [copied, setCopied] = useState(false);

  const handleCopyCoupon = async () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, delay);
    try {
      await navigator.clipboard.writeText(couponCode || '');
    } catch (error) {
      console.error('Failed to copy coupon:', error);
    }
  };

  return { copied, handleCopyCoupon };
};

export default useCopy;
